// @flow
import type {CustomerAddressesListType} from 'constants/flow/flowTypesCheckout';

const initialState = {
    addressesList: [],
    currentShippingAddress: '0',
    currentBillingAddress: '0',
    status: '',
};

/**
 * Fetch a customer addresses list
 * @param {object} state Current state
 * @param {object} action Received action
 * @return {Array<AddressType>} Customer addresses list
 */
export default function addresses(
    state: CustomerAddressesListType = initialState,
    action: {type: string, [string]: any},
): CustomerAddressesListType {
    switch (action.type) {
        case 'FETCH_CUSTOMER_ADDRESSES_FULFILLED':
            if (action.payload.data.addresses.length > 0) {
                return {
                    addressesList: action.payload.data.addresses,
                    currentShippingAddress: action.payload.data.billing_address_id,
                    currentBillingAddress: action.payload.data.shipping_address_id,
                    status: 'fulfilled',
                };
            }

            return state;

        case 'REMOVE_CUSTOMER_ADDRESS_FULFILLED':
            return {
                ...state,
                addressesList: action.payload.data,
            };

        default:
            return state;
    }
}
